// Shared GSAP setup: plugin registration, reduced-motion check, and a few
// tiny helpers the modules reuse for small UI transitions.
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export { gsap, ScrollTrigger, SplitText };

export const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Fade-and-rise a set of elements (used when UI content swaps in place).
export function swapIn(targets, { y = 14, stagger = 0.05, duration = 0.45 } = {}) {
  if (reducedMotion() || !targets || (targets.length === 0)) return;
  gsap.fromTo(targets, { y, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration, stagger, ease: "power3.out", overwrite: "auto", clearProps: "transform,visibility,opacity" });
}
